<script setup lang="ts">
import { computed } from "vue";

const props = withDefaults(
  defineProps<{
    value?: number;
    max?: number;
    color?: string;
    label?: string;
    caption?: string;
  }>(),
  { value: 0, max: 100, color: "var(--fuel-carb)" },
);

const pct = computed(() => Math.max(0, Math.min(100, (props.value / props.max) * 100)));
</script>
<template>
  <div class="cw-bar">
    <div
      class="cw-bar__track"
      role="progressbar"
      :aria-valuenow="value"
      :aria-valuemax="max"
    >
      <div
        class="cw-bar__fill"
        :style="{ width: `${pct}%`, background: color }"
      />
      <slot name="marker" />
    </div>
    <div
      v-if="label || caption"
      class="cw-bar__meta"
    >
      <span>{{ label }}</span>
      <span>{{ caption }}</span>
    </div>
  </div>
</template>
